import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
const _hoisted_2 = {
  class: "mr-1 flex"
};
const _hoisted_3 = {
  class: "mr-1"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TransferNotification',
  props: {
    notification: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_RouterLink = _resolveComponent("RouterLink");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.notification.payload.inOut === 'out' ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        icon: _ctx.IconEnum.ArrowLeft,
        size: "1rem",
        class: "text-red-600"
      }, null, 8, ["icon"])) : (_openBlock(), _createBlock(_component_Icon, {
        key: 1,
        icon: _ctx.IconEnum.ArrowRight,
        size: "1rem",
        class: "text-green-600"
      }, null, 8, ["icon"]))]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$money(__props.notification.payload.price)), 1), _createElementVNode("div", null, [_createVNode(_component_RouterLink, {
        class: "text-green-600 font-bold",
        to: {
          name: 'players.show',
          params: {
            id: __props.notification.payload.playerId
          }
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.notification.payload.playerName), 1)]),
        _: 1
      }, 8, ["to"])])]);
    };
  }
});